<template>
  <div class="weather-fill clearfix">
    <el-form label-width="20px" :model="form" style="width:80%;">
      <el-form-item label="">
        <p class="b_p">风险等级：</p>
        <el-radio-group v-model="form.riskLevel" size="small">
          <el-radio :label="1" disabled>一般</el-radio>
          <el-radio :label="2" disabled>较大</el-radio>
          <el-radio :label="3" disabled>重大</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="">
        <p class="b_p">是否涉及简化备案：</p>
        <el-radio-group v-model="form.simplifyFlag" size="small">
          <el-row>
            <el-col :span="24">
              <el-radio :label="1" disabled>不涉及</el-radio>
            </el-col>
            <el-col :span="24">
              <el-radio :label="2" disabled>涉及，不产生危险废物，所有Q值累计值小于1</el-radio>
            </el-col>
            <el-col :span="24">
              <el-radio :label="3" disabled>涉及，产生危险废物，所有Q值累计值小于1且年产生危险废物小于10吨</el-radio>
            </el-col>
            <el-col :span="24">
              <el-radio :label="4" disabled>回顾性简化备案</el-radio>
            </el-col>
          </el-row>
        </el-radio-group>
      </el-form-item>
      <!--<el-form-item label="">
        <p class="b_p">企业规模：</p>
        <el-radio-group v-model="form.enterpriseScale" size="small">
          <el-radio :label="1" disabled>小型</el-radio>
          <el-radio :label="2" disabled>中型</el-radio>
          <el-radio :label="3" disabled>大型</el-radio>
        </el-radio-group>
      </el-form-item>-->
      <el-form-item label="" style="width:300px;">
        <p class="b_p">厂区面积：{{form.factoryArea}}<span style="padding-left: 5px;">平方米</span></p>
      </el-form-item>
      <el-form-item label="" style="width:300px;">
        <p class="b_p">从业人数：{{form.employeesNum}} <span style="padding-left: 5px;">人</span></p>
      </el-form-item>
      <el-form-item label="" class="arr_b">
        <p class="b_p">可能发生突发环境事件情景：</p>
        <el-checkbox-group v-model="checkList">
          <el-checkbox label="1" disabled>火灾、爆炸、泄漏等生产安全事故及可能引起的次生、衍生 厂外环境污染及人员伤亡事故（例如，因生产安全事故导致有毒有 害气体扩散出厂界，消防水、物料泄漏物及反应生成物，从雨水排 口、清净下水排口、污水排口、厂门或围墙排出厂界，污染环境等）</el-checkbox>
          <el-checkbox label="2" disabled>环境风险防控设施失灵或非正常操作（如雨水阀门不能正常 关闭，化工行业火炬意外灭火）</el-checkbox>
          <el-checkbox label="3" disabled>非正常工况（如开、停车等）;</el-checkbox>
          <el-checkbox label="4" disabled>污染治理设施非正常运行;</el-checkbox>
          <el-checkbox label="5" disabled>违法排污；</el-checkbox>
          <el-checkbox label="6" disabled>停电、断水、停气等;</el-checkbox>
          <el-checkbox label="7" disabled>通讯或运输系统故障;</el-checkbox>
          <el-checkbox label="8" disabled>各种自然灾害、极端天气或不利气象条件；</el-checkbox>
          <el-checkbox label="9" disabled>其他可能的情景。</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import workbrnch from './../../data/emer/burst.js'
export default {
  data() {
    return {
      // 基本信息
      form: {
        employeesNum: 0,
//      enterpriseScale: 1,
        factoryArea: 0,
        planId: '',
        riskLevel: 1,
        situation: '2'
      },
      planId: '',
      checkList: []
    }
  },
  created() {
    if (!sessionStorage.planIdLists) return
    this.planId = sessionStorage.planIdLists
    this.get_basic_detail()
  },
  methods: {

    // 获取详情
    get_basic_detail() {
      (async() => {
        try {
          let info = await workbrnch.get_basic_detail({
            planId: this.planId
          })
          if (info.status) {
            this.form = info.data
            if (info.data.situation == null) {
              this.checkList = []
            } else {
              this.checkList = info.data.situation.split(',')
            }
          }
        } catch (err) {
          console.log(err)
        }
      })()
    }
  },
}
</script>
<style scoped lang="stylus">
.weather-fill {
    position: relative;
  overflow: auto;
  height: 588px;
}

.el-checkbox,
.el-checkbox__input {
  white-space: normal
}

.el-form-item__content {
  position: relative;
  left: -15px;
}

.el-checkbox-group {
  label {
    display: block;
    line-height: 30px;
    &:nth-child(n+1) {
      margin-left: 0;
    }
    span {
      word-break: normal;
      width: auto;
      display: block;
      white-space: pre-wrap;
      word-wrap: break-word;
      overflow: hidden;
    }
  }
}

.b_p {
  position: relative;
  left: 0px;
  font-weight: bold;
}

.el-form-item {
  margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// infovue.vue?292c52fc